<template>
  <div>
    <Header :items="navigation_lables" :parentHandler="handleNavigation" />
    <div class="flex">
      <div class="w-0 md:w-1/6 md:visible invisible bg-gray-800">
        <sidebar
          title="Navigation"
          :items="navigation_lables"
          :parentHandler="handleNavigation"
        />
      </div>
      <div class="xl:w-4/5 w-full bg-gray-700 mx-auto">
        <div v-for="i in navigation_lables" :key="i.id">
          <div v-if="i.replace(/\s/g, '') == selected">
            <!-- My Selection -->
            <component v-if="selected == 'MySelection' && !isChoosingModules"
            v-bind:is="selected">
            </component>

            <!-- Choose Modules -->
             <choose-modules
             v-if="isChoosingModules"
            :isCurrentYear="isCurrentYear"
            :pageTitle="pageTitle"
            :pageIcon="pageIcon"
            :stage="stage">
            </choose-modules>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar';
import Header from './Header';
import ChooseModules from './ChooseModules';
import MySelection from './MySelection';

export default {
  components: {
    Header,
    Sidebar,
    MySelection,
    ChooseModules,
  },
  data: () => ({
    navigation_lables: [],
    selected: '',
    isChoosingModules: false,
  }),
  mounted() {
    this.getEnabled();
  },
  methods: {
    /**
     * Replace selected with the name of the selected
     *  navigation item without spaces
     * @param {String} link
     */
    handleNavigation(link) {
      this.selected = link.replace(/\s/g, '');
      /* Choose Current Year */
      if (this.selected == 'ChooseCurrentYear') {
        this.isChoosingModules = true;
        this.isCurrentYear = true;
        this.pageTitle = link.replace(/([A-Z])/g, ' $1').trim();
        this.pageIcon = 'fas fa-book font-bold my-1 p-2 mr-1 text-l';
        this.stage = localStorage.getItem('stage');
      /* Choose Next Year */
      } else if (this.selected == 'ChooseNextYear') {
        this.isChoosingModules = true;
        this.isCurrentYear = false;
        this.pageTitle = link.replace(/([A-Z])/g, ' $1').trim();
        this.pageIcon = 'fas fa-book-open font-bold my-1 p-2 mr-1 text-l';
        this.stage = parseInt(localStorage.getItem('stage')) + 1;
      } else {
        this.isChoosingModules = false;
        this.isCurrentYear = false;
        this.pageTitle = '';
        this.pageIcon = '';
      }
    },

    /**
     * Gets the enabled pages to show for the student.
     */
    getEnabled: function() {
      fetch(
        `${process.env.VUE_APP_API_URL}/get_enabled_selections`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jwt: localStorage.getItem('jwt'),
          }),
        },
      )
        .then((r) => {
          return r.json();
        })
        .then((response) => {
          // console.log('Response Data:', response.data);
          // console.log(response.data[0]);
          let lables = [
            'My Selection',
            'Choose Current Year',
            'Choose Next Year',
          ];

          if (!response.data[0].module_selection_enabled) {
            lables = [];
          }

          // can only choose if there is a programme
          const noProgramme = localStorage.getItem('prog') == 0
          if (noProgramme || !response.data[0].current_year_enabled) {
            lables = lables.filter((e) => e !== 'Choose Current Year');
          }
          if (noProgramme || !response.data[0].next_year_enabled) {
            lables = lables.filter((e) => e !== 'Choose Next Year');
          }
          this.navigation_lables = lables;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
